import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdministrationService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  getCommunities(administrationId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/communities`;
    return this.get(this.endpoint);
  }

  getInfo(administrationId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/info`;
    return this.get(this.endpoint);
  }

  getCollectionsMethods(): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/common-expense/collections-methods`;
    return this.get(this.endpoint);
  }

  postConfigreCollections(data: any, communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/collections-methods`;
    return this.post(this.endpoint, data);
  }

  getFirstPeriod(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/perido-first`;
    return this.get(this.endpoint);
  }

  updateCollectionsMethods(data, communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/collections-methods`;
    return this.put(this.endpoint, data);
  }

  deleteCommunity(administrationId: number, communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administration/${administrationId}/community/${communityId}/delete`;
    return this.delete(this.endpoint);
  }

  getCollectionsMethodUsed(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/common-expense/collection-method-used`;
    return this.get(this.endpoint);
  }

  getListCommunities(administrationId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}`;
    return this.get(this.endpoint);
  }

  getAdministrationSetting(administrationId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/settings`;
    return this.get(this.endpoint);
  }

  getAdministrationById(administrationId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}`;
    return this.get(this.endpoint);
  }

  updateAdministrationImage(administrationId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/edit/image`;
    return this.put(this.endpoint, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/administration.service.ts